export default "__VITE_ASSET__g8dFNtsw__"